var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/cart-confirm-quantity.j2"] = require( "header/cart-confirm-quantity.j2" );
dependencies["header/cart-confirm-image.j2"] = require( "header/cart-confirm-image.j2" );
dependencies["header/cart-confirm-meta.j2"] = require( "header/cart-confirm-meta.j2" );
dependencies["header/cart-confirm-button.j2"] = require( "header/cart-confirm-button.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart-confirm.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/cart-confirm.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("checkoutUrl")) {
var t_4 = t_1.checkoutUrl;
} else {
cb(new Error("cannot import 'checkoutUrl'")); return;
}
context.setVariable("checkoutUrl", t_4);
if(t_1.hasOwnProperty("imageUrl")) {
var t_5 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_5);
var t_6;
t_6 = (lineno = 3, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.cart.showConfirm",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("showDropdownConfirmation", t_6, true);
if(frame.topLevel) {
context.setVariable("showDropdownConfirmation", t_6);
}
if(frame.topLevel) {
context.addExport("showDropdownConfirmation", t_6);
}
output += "\n\n<div role=\"dialog\" class=\"c-cart-confirm js-cart-confirm";
if(runtime.contextOrFrameLookup(context, frame, "showDropdownConfirmation")) {
output += " is-shown";
;
}
output += " dom-cart-confirm\" data-qa-cart-confirm>";
if(runtime.contextOrFrameLookup(context, frame, "showDropdownConfirmation")) {
output += "\n\n    ";
var t_7;
t_7 = (lineno = 10, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.limitCartQualifierToLoyalty",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("cartQualifierLimitedToLoyalty", t_7, true);
if(frame.topLevel) {
context.setVariable("cartQualifierLimitedToLoyalty", t_7);
}
if(frame.topLevel) {
context.addExport("cartQualifierLimitedToLoyalty", t_7);
}
output += "\n    ";
var t_8;
t_8 = (runtime.contextOrFrameLookup(context, frame, "cartQualifierLimitedToLoyalty")?(lineno = 11, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyalty",runtime.contextOrFrameLookup(context, frame, "False")])):runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("showQualifier", t_8, true);
if(frame.topLevel) {
context.setVariable("showQualifier", t_8);
}
if(frame.topLevel) {
context.addExport("showQualifier", t_8);
}
output += "\n    ";
var t_9;
t_9 = (lineno = 12, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ab.SS_QUALIFIER",""])) == 1;
frame.set("haveClosenessQualifierCookie", t_9, true);
if(frame.topLevel) {
context.setVariable("haveClosenessQualifierCookie", t_9);
}
if(frame.topLevel) {
context.addExport("haveClosenessQualifierCookie", t_9);
}
output += "\n    ";
var t_10;
t_10 = (lineno = 13, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.cartQualifierThreshold",0]));
frame.set("cartQualifierThreshold", t_10, true);
if(frame.topLevel) {
context.setVariable("cartQualifierThreshold", t_10);
}
if(frame.topLevel) {
context.addExport("cartQualifierThreshold", t_10);
}
output += "\n    ";
var t_11;
t_11 = (lineno = 14, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.cart.discountableSubtotal",0]));
frame.set("discountableSubtotal", t_11, true);
if(frame.topLevel) {
context.setVariable("discountableSubtotal", t_11);
}
if(frame.topLevel) {
context.addExport("discountableSubtotal", t_11);
}
output += "\n    ";
var t_12;
t_12 = (lineno = 15, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.cart.qualifiedForFreeShipping",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("qualifiedForFreeShipping", t_12, true);
if(frame.topLevel) {
context.setVariable("qualifiedForFreeShipping", t_12);
}
if(frame.topLevel) {
context.addExport("qualifiedForFreeShipping", t_12);
}
output += "\n    ";
var t_13;
t_13 = (lineno = 16, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.cartQualifiedAnimation.fields.file.url",""]));
frame.set("cartQualifiedAnimationUrl", t_13, true);
if(frame.topLevel) {
context.setVariable("cartQualifiedAnimationUrl", t_13);
}
if(frame.topLevel) {
context.addExport("cartQualifiedAnimationUrl", t_13);
}
output += "\n    ";
var t_14;
t_14 = "";
frame.set("ineligibleCartMessage", t_14, true);
if(frame.topLevel) {
context.setVariable("ineligibleCartMessage", t_14);
}
if(frame.topLevel) {
context.addExport("ineligibleCartMessage", t_14);
}
output += "\n\n    ";
if((lineno = 19, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.cart.meta.includesNonDiscountableItems",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n        ";
var t_15;
t_15 = (lineno = 20, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-progress__ineligible-non-discountable"]));
frame.set("ineligibleCartMessage", t_15, true);
if(frame.topLevel) {
context.setVariable("ineligibleCartMessage", t_15);
}
if(frame.topLevel) {
context.addExport("ineligibleCartMessage", t_15);
}
output += "\n    ";
;
}
else {
if((lineno = 21, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.cart.meta.includesFlatRateItems",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n        ";
var t_16;
t_16 = (lineno = 22, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-progress__ineligible-flat-rate"]));
frame.set("ineligibleCartMessage", t_16, true);
if(frame.topLevel) {
context.setVariable("ineligibleCartMessage", t_16);
}
if(frame.topLevel) {
context.addExport("ineligibleCartMessage", t_16);
}
output += "\n    ";
;
}
;
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "showQualifier") && runtime.contextOrFrameLookup(context, frame, "haveClosenessQualifierCookie") && runtime.contextOrFrameLookup(context, frame, "cartQualifierThreshold") > 0) {
output += "\n\n        <div class=\"o-row c-cart-progress ";
if(runtime.contextOrFrameLookup(context, frame, "discountableSubtotal") >= runtime.contextOrFrameLookup(context, frame, "cartQualifierThreshold")) {
output += "c-cart-progress--qualified";
;
}
output += "\">\n\n            <div class=\"o-column\">\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "ineligibleCartMessage")) {
output += "\n\n                    <div class=\"c-cart-progress__ineligible\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ineligibleCartMessage"), env.opts.autoescape);
output += "</div>\n\n                ";
;
}
else {
output += "\n\n                    <div>\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "discountableSubtotal") >= runtime.contextOrFrameLookup(context, frame, "cartQualifierThreshold")) {
output += "\n\n                            ";
if(!runtime.contextOrFrameLookup(context, frame, "qualifiedForFreeShipping")) {
output += "\n                                <img class=\"c-cart-progress__image\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cartQualifiedAnimationUrl"), env.opts.autoescape);
output += "\" alt=\"\">\n                            ";
;
}
output += "\n\n                            <p class=\"c-cart-progress__success-header\">\n                                ";
output += runtime.suppressValue((lineno = 46, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-progress__success-header"])), env.opts.autoescape);
output += "\n                            </p>\n                            <p class=\"c-cart-progress__success-text\">\n                                ";
output += runtime.suppressValue((lineno = 49, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-progress__success-text"])), env.opts.autoescape);
output += "\n                            </p>\n\n                        ";
;
}
else {
output += "\n\n                            <p class=\"c-cart-progress__message\">\n                                ";
var t_17;
t_17 = env.getFilter("currency").call(context, env.getFilter("round").call(context, (runtime.contextOrFrameLookup(context, frame, "cartQualifierThreshold") - runtime.contextOrFrameLookup(context, frame, "discountableSubtotal")),2),runtime.contextOrFrameLookup(context, frame, "core"));
frame.set("priceDifference", t_17, true);
if(frame.topLevel) {
context.setVariable("priceDifference", t_17);
}
if(frame.topLevel) {
context.addExport("priceDifference", t_17);
}
output += "\n                                ";
output += runtime.suppressValue((lineno = 56, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-progress__lead-message",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "priceDifference")]})])), env.opts.autoescape);
output += "\n                            </p>\n\n                        ";
;
}
output += "\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "qualifiedForFreeShipping")) {
output += "\n\n                            <div class=\"c-cart-progress__bar-outer\">\n                                <div class=\"c-cart-progress__bar js-cart-confirm-progress-bar\"></div>\n                            </div>\n\n                            <p class=\"c-cart-progress__bar-label\">";
output += runtime.suppressValue(env.getFilter("currency").call(context, 0,runtime.contextOrFrameLookup(context, frame, "core")), env.opts.autoescape);
output += "</p>\n                            <p class=\"c-cart-progress__bar-label c-cart-progress__bar-label--end\">";
output += runtime.suppressValue(env.getFilter("currency").call(context, runtime.contextOrFrameLookup(context, frame, "cartQualifierThreshold"),runtime.contextOrFrameLookup(context, frame, "core")), env.opts.autoescape);
output += "</p>\n\n                        ";
;
}
output += "\n\n                    </div>\n\n                ";
;
}
output += "\n\n            </div>\n\n        </div>\n\n    ";
;
}
output += "\n\n    <a href=\"";
output += runtime.suppressValue((lineno = 81, colno = 25, runtime.callWrap(t_4, "checkoutUrl", context, [])), env.opts.autoescape);
output += "\" rel=\"nofollow\" id=\"a-cart-confirm\" class=\"c-cart-confirm__a\" role=\"status\" aria-live=\"polite\" aria-labelledby=\"cart-confirm-text\" data-qa-confirm-checkout-button>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--12\">\n\n                ";
env.getTemplate("header/cart-confirm-quantity.j2", false, "core/templates/header/cart-confirm.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row c-cart-confirm__extra-details\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--4\">\n\n                ";
env.getTemplate("header/cart-confirm-image.j2", false, "core/templates/header/cart-confirm.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-medium--8\">\n\n                ";
env.getTemplate("header/cart-confirm-meta.j2", false, "core/templates/header/cart-confirm.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-small--8 o-small--centered o-medium--12\">\n\n                ";
env.getTemplate("header/cart-confirm-button.j2", false, "core/templates/header/cart-confirm.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "\n\n            </div>\n\n        </div>\n\n    </a>\n\n";
})})})})})})})});
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart-confirm.j2"] , dependencies)